import { Box, Skeleton } from '@factorialco/deprecated-design-system'
import { times } from 'lodash'

const MessageAttachmentsSkeleton = () => (
  <Box width="full" gap="s8">
    <Skeleton width="s120" height="s16" />
    <Box paddingY="s6" gap="s12">
      {times(2).map((_, index) => (
        <Skeleton width="full" height="s48" key={index} />
      ))}
    </Box>
  </Box>
)

export default MessageAttachmentsSkeleton
